import type { UploadScope as UploadScopeType } from '#layers/assets/public';
import { joinURL } from 'ufo';
import { useRuntimeConfig } from '#app/nuxt';
import { UploadScope } from '#layers/assets/public';
import { isPromiseResultRejected, useWorkspaceApiBaseUrl } from '#layers/base/public';

/**
 * Deletes a file from the assets endpoint
 */
export async function deleteFile(id: string, scope: UploadScopeType = UploadScope.Workspace) {
	const runtimeConfig = useRuntimeConfig();

	const basePath = scope === UploadScope.System
		? joinURL(runtimeConfig.public.api, 'system', 'assets', id)
		: joinURL(useWorkspaceApiBaseUrl(), 'assets', id);

	return $fetch(basePath, {
		method: 'DELETE',
	});
}

export function createFileHooks(scope: UploadScopeType = UploadScope.Workspace) {
	return {
		async delete({ key }: { key: string | number }) {
			await deleteFile(key as string, scope);
		},
		async deleteMany({ keys }: { keys: Array<string | number> }) {
			const results = await Promise.allSettled(keys.map((id) => deleteFile(id as string, scope)));

			if (results.some((result) => isPromiseResultRejected(result))) {
				throw new Error(`Failed to delete files ${results.map((_, index) => keys[index]).join(', ')} from storage.`);
			}
		},
	};
}
